import Swal from "sweetalert2";
import { showDialogCustomizable } from "./showDialogCustom";
import { ConfirmEditDialog } from "./ConfirmEditDialog";
import { ConfirmAnnullaDialog } from "./ConfirmAnnullaDialog";
import { ConfirmSalvaDialog } from "./ConfirmSalvaDialog";
import { ConfirmValidationDialog } from "./ConfirmValidationDialog";
import DialogNewReportForm from "./DialogNewReportForm";
import ConfirmAddVenueDialog from "./ConfirmAddVenueDialog";
import ConfirmRemoveVenueDialog from "./ConfirmRemoveVenueDialog";
import SelectCategoriaDialog from "./SelectCategoriaDialog";

export const showDialogNewReport = (
  onConferma: (
    name: string,
    description: string,
    bankNames: string[],
    referenceYear: number,
  ) => Promise<void>,
  onAnnulla?: () => void
) => {
  const content = (
    <DialogNewReportForm
      onConferma={onConferma}
      onAnnulla={() => {
        onAnnulla?.();
      }}
    />
  );

  showDialogCustomizable(content); 
};

export const showDialogConfermaModifica = (onConferma: () => void, onAnnulla?: () => void) => {
  const handleConferma = () => {
    onConferma();    
    Swal.close();     
  };

  const content = (
    <ConfirmEditDialog
      onConferma={handleConferma}
      onAnnulla={() => {
        onAnnulla?.();
        Swal.close();
      }}
    />
  );

  showDialogCustomizable(content, '', '', '', handleConferma, false, '360px');
};

export const showDialogConfermaAnnulla = (onConferma: () => void) => {
  const handleConferma = () => {
    onConferma();
    Swal.close();
  };

  const content = (
    <ConfirmAnnullaDialog
      onConferma={handleConferma}
      onAnnulla={() => Swal.close()}
    />
  );

  showDialogCustomizable(content, '', '', '', handleConferma, false, '360px');
};

const SaveToast = Swal.mixin({
  toast: true,
  position: 'bottom-end',
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
});

export const showDialogConfermaSalva = (onConferma: () => void | Promise<void>) => {
  const handleConferma = async () => {
    try {
      await onConferma();
      Swal.close();
      SaveToast.fire({
        icon: 'success',
        title: 'Modifiche salvate!',
        text: 'Le modifiche sono state salvate correttamente.',
      });
    } catch (err: any) {
      Swal.close();
      SaveToast.fire({
        icon: 'error',
        title: 'Errore di salvataggio',
        text: err?.message ?? 'Si è verificato un errore durante il salvataggio.',
      });
    }
  };

  const content = (
    <ConfirmSalvaDialog
      onConferma={handleConferma}
      onAnnulla={() => Swal.close()}
    />
  );

  showDialogCustomizable(content, '', '', '', handleConferma, false, '360px');
};

export const showDialogConfermaValidazione = (onConferma: () => void, onAnnulla?: () => void) => {
  const content = (
    <ConfirmValidationDialog
      onConferma={onConferma}
      onAnnulla={() => {
        onAnnulla?.();
        Swal.close();
      }}
    />
  );

  showDialogCustomizable(content, '', '', '', onConferma, false);
};

export const showDialogConfermaAggiuntaVenue = (
  onConferma: () => void,
  onAnnulla?: () => void
) => {
  const handleConferma = () => {
    onConferma();
    Swal.close();
  };

  const content = (
    <ConfirmAddVenueDialog
      onConferma={handleConferma}
      onAnnulla={() => {
        onAnnulla?.();
        Swal.close();
      }}
    />
  );

  showDialogCustomizable(content, '', '', '', handleConferma, false);
};

export const showDialogConfermaRimozioneVenue = (
  onConferma: () => void,
  onAnnulla?: () => void
) => {
  const handleConferma = () => {
    onConferma();
    Swal.close();
  };

  const content = (
    <ConfirmRemoveVenueDialog
      onConferma={handleConferma}
      onAnnulla={() => {
        onAnnulla?.();
        Swal.close();
      }}
    />
  );

  showDialogCustomizable(content, '', '', '', handleConferma, false);
};


export const showDialogSelectCategoria = (
  onConferma: (categoriaSelezionata: string) => void,
  onAnnulla?: () => void
) => {
  const handleConferma = (categoriaSelezionata: string) => {
    onConferma(categoriaSelezionata);
    Swal.close();
  };

  const content = (
    <SelectCategoriaDialog
      onConferma={handleConferma}
      onAnnulla={() => {
        onAnnulla?.();
        Swal.close();
      }}
    />
  );

  showDialogCustomizable(content, '', '', '', () => {}, false);
};